import React, { Component } from "react";
import Checkbox from "./KnoaCheckbox";
import { withTranslation } from "react-i18next";

export class ListSelect extends Component {
    render() {
        const { data, handleAddToProjectUpdateCheckbox, ariaLabelledByIds, t } = this.props;

        if (data && data.length > 0) {
            const tasks = data.map((item, i) => (
                <tr key={i} className="listSelect-tr">
                    <td className="listSelect-td-cb">
                        <Checkbox
                            number={item.id}
                            isChecked={item.checked}
                            handleAddToProjectUpdateCheckbox={handleAddToProjectUpdateCheckbox}
                            label={item.name}
                            srOnlyLabel
                        />
                    </td>
                    <td className="listSelect-td-projectnames">{item.name}</td>
                </tr>
            ));

            return (
                <div role="group" aria-labelledby={ariaLabelledByIds}>
                    <table className="table" style={{ overflow: "auto" }}>
                        <tbody
                            className={
                                data.length > 5
                                    ? "listSelect-body-long"
                                    : "listSelect-body-short"
                            }
                        >
                        {tasks}
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return (
                <tbody className="listSelect-span-info">
                <tr>
                    <td>
                        <i className="fa fa-exclamation-circle" />
                        {t("dialog:addToProjectInfo")}
                    </td>
                </tr>
                </tbody>
            );
        }
    }
}

export default withTranslation()(ListSelect);